<template>
  <div>
    <v-container class="bdo-login-container" fluid>
      <v-row>
        <v-col md="4" offset-md="4">
          <v-card>
            <v-card-title>
              <h3>Select your country</h3>
            </v-card-title>
            <v-select
              :loading="loading_countries"
              :disabled="loading_countries"
              v-model="selected_country"
              :items="all_countries"
              label="Countries"
              item-value="code"
              item-text="name"
              class="pl-4 pr-4"
              dense
              outlined
              solo
              flat
            >
            </v-select>
            <v-btn
              class="primary-btn ml-4 mb-4"
              :loading="submitted"
              :disabled="!selected_country"
              v-on:click="selectCountry()"
            >
              Select »
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import helpers from '@/plugins/helpers'
import { mapGetters } from 'vuex'
import config from '@/config'
export default {
  data: () => ({
    all_countries: [],
    selected_country: '',
    loading_countries: true,
    submitted: false,
    _csrf: ''
  }),
  computed: {
    ...mapGetters({
      user: 'general/user',
      countrycode: 'general/countrycode'
    })
  },
  mounted() {
    if (this.user.id && this.$route.name === 'Root') {
      this.$router.push(`${this.countrycode}/questionnaires`)
    }
    this.allCountries()
  },
  methods: {
    async allCountries() {
      // No use of GraphQL because we have no user, so no JWT for the graphQL call.
      let response = await helpers.fetchApi(config.apiUrl + 'countries', 'GET')
      if (response.countries) {
        this.$store.commit('general/SET_TEMPORARY_CSRF', response.csrf)
        this.all_countries = response.countries
      } else if (response.redirect_url) {
        window.location.href = response.redirect_url
      } else {
        console.log('Something went wrong')
      }
      this.loading_countries = false
    },
    async selectCountry() {
      this.submitted = true
      let response = await helpers.fetchApi(config.apiUrl + 'select-country', 'POST', {
        country_code: this.selected_country,
        _csrf: this.$store.state.general.tempcsrf
      })
      if (response.country_code) {
        this.submitted = false
        this.$router.push({ name: 'Login', params: { countrycode: response.country_code, allowed: true } })
      } else if (response.redirect_url) {
        window.location.href = response.redirect_url
      } else {
        console.log('Something went wrong')
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/style/_variables.scss';
.primary-btn {
  color: white !important;
  background: $bdo-red !important;
}
</style>
